import React from 'react';
import Navbar from '../components/Navbar';
import './WeddingParty.css';

const WeddingParty = () => {
    return (
        <div>
            <Navbar />
            <section className="wedding-party section">
                <div className="wedding-party-container">
                    <hr className="divider" /> {/* Top Divider */}
                    <h1 className="section-title">The Wedding Party</h1>

                    {/* First Row: Maid of Honor and Best Man */}
                    <div className="party-row">
                        <div className="party-member">
                            <h2 className="member-title">Maid of Honor</h2>
                            <p className="member-name">Conductor Nicole Negrete</p>
                            <p className="member-description">
                                Nicole isn’t just Seneca’s Maid of Honor -- she’s her little sister and forever best friend. From 
                                sharing childhood giggles to being each other’s confidant through life’s hardships, Nicole has 
                                always been by Seneca’s side. While Seneca is known for her thoughtful and cautious approach, 
                                Nicole proudly embraces her role as the family’s “wild child” and is ready to bring the energy 
                                to this celebration. Whether it’s offering a helping hand, sparking laughter, or leading the 
                                charge on the dance floor, Nicole is here to make sure this wedding is unforgettable. Get ready 
                                to party but, until then you can find her workin on the railroad! Chooo chooo
                            </p>
                        </div>
                        <div className="party-member">
                            <h2 className="member-title">Best Man</h2>
                            <p className="member-name">Dr. Alex Decilveo</p>
                            <p className="member-description">
                                The wild card of the family. While Tim's the guy you call for a savings plan, Alex is the one 
                                convincing you to blow it on a weekend trip to Miami or a Japanese wagyu steak that's probably 
                                not actually from Japan. Rough around the edges but impossible not to like, he's funnier, louder, 
                                and more extroverted than Tim -- basically, the brother who makes life outlandishly more expensive, 
                                but a lot more entertaining.
                            </p>
                        </div>
                    </div>

                    {/* Second Row: Flower Girl and Ring Bearer */}
                    <div className="party-row">
                        <div className="party-member">
                            <h2 className="member-title">Flower Girl</h2>
                            <p className="member-name">Ohleena Paea</p>
                            <p className="member-description">
                                Ohleena is Seneca’s only niece and the proud flower girl of the family. She began her flower girl 
                                career at just 3 years old, and with a few weddings under her belt, she’s now the go-to petal tosser 
                                for all big events. When she’s not walking down the aisle, Ohleena can be found on the rugby field or 
                                softball diamond, channeling her inner athlete. Though she’s not entirely thrilled about sharing her 
                                Tía with Tim, she has to admit -- he’s the perfect guy for Seneca to drive crazy for the rest of their lives. 
                                Ohleena is excited to make her flower girl magic happen at the wedding and can’t wait to see everyone there!
                            </p>
                        </div>
                        <div className="party-member">
                            <h2 className="member-title">Ring Bearer</h2>
                            <p className="member-name">Zachary Williams</p>
                            <p className="member-description">
                                Zachary is Seneca's bonus nephew! He came into her life 13 years ago and shares her love of shoes and travel.
                                He is very proud to be the ring bearer (keeper of jewels) for her upcoming marriage to Tim. He considers himself
                                very responsible, a ridiculously good athlete, and a student that sometimes is smarter than all of his teachers'
                                collective brain power. He is honored to be a part of Seneca and Tim's special day!

                            </p>
                        </div>
                    </div>
                    <hr className="divider" /> {/* Bottom Divider */}
                </div>
            </section>
        </div>
    );
};

export default WeddingParty;
